<div class="forgot-page">
  <p-toast />

  <!-- Lado Esquerdo - Hero Section -->
  <div class="forgot-hero">
    <div class="hero-content">
      <!-- Logo -->
      <div class="hero-logo">
        <img src="assets/images/logo_avatipro.png" alt="Avati Pro" />
      </div>

      <!-- Titulo Principal -->
      <h1 class="hero-title">{{ 'forgot-password.hero.titulo' | translate }}</h1>
      <p class="hero-subtitle">{{ 'forgot-password.hero.subtitulo' | translate }}</p>

      <!-- Icone Central Ilustrativo -->
      <div class="hero-illustration">
        <div class="illustration-circle">
          <i class="pi pi-lock"></i>
        </div>
        <div class="illustration-waves">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <!-- Dicas de Seguranca -->
      <div class="security-tips">
        <div class="tip-item">
          <i class="pi pi-shield"></i>
          <span>{{ 'forgot-password.tips.seguro' | translate }}</span>
        </div>
        <div class="tip-item">
          <i class="pi pi-clock"></i>
          <span>{{ 'forgot-password.tips.rapido' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Circulos Decorativos -->
    <div class="decorative-circle circle-1"></div>
    <div class="decorative-circle circle-2"></div>
    <div class="decorative-circle circle-3"></div>
  </div>

  <!-- Lado Direito - Formularios -->
  <div class="forgot-form-section">
    <div class="form-container">
      <!-- ================================================================== -->
      <!-- STEP 1: Solicitar Email -->
      <!-- ================================================================== -->
      <ng-container *ngIf="step === 1">
        <!-- Header do Formulario -->
        <div class="form-header">
          <div class="step-indicator">
            <div class="step active">1</div>
            <div class="step-line"></div>
            <div class="step">2</div>
            <div class="step-line"></div>
            <div class="step">3</div>
          </div>
          <h2>{{ 'forgot-password.step1.titulo' | translate }}</h2>
          <p>{{ 'forgot-password.step1.subtitulo' | translate }}</p>
        </div>

        <!-- Formulario -->
        <div class="form-content">
          <div class="input-group">
            <label for="email">{{ 'forgot-password.labels.email' | translate }}</label>
            <div class="input-wrapper">
              <i class="pi pi-envelope input-icon"></i>
              <input
                pInputText
                id="email"
                [(ngModel)]="email"
                type="email"
                [placeholder]="'forgot-password.placeholders.usuario_dominio_com' | translate"
                autocomplete="off"
              />
            </div>
          </div>

          <!-- Botoes -->
          <div class="buttons-group">
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.voltar' | translate"
              icon="pi pi-arrow-left"
              class="btn-secondary"
              (click)="backToLogin()"
            ></button>
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.enviar_codigo' | translate"
              icon="pi pi-send"
              iconPos="right"
              class="btn-primary"
              [loading]="enviandoCodigo"
              [disabled]="enviandoCodigo"
              (click)="sendCode()"
            ></button>
          </div>
        </div>
      </ng-container>

      <!-- ================================================================== -->
      <!-- STEP 2: Inserir Codigo -->
      <!-- ================================================================== -->
      <ng-container *ngIf="step === 2">
        <!-- Header do Formulario -->
        <div class="form-header">
          <div class="step-indicator">
            <div class="step completed"><i class="pi pi-check"></i></div>
            <div class="step-line completed"></div>
            <div class="step active">2</div>
            <div class="step-line"></div>
            <div class="step">3</div>
          </div>
          <h2>{{ 'forgot-password.step2.titulo' | translate }}</h2>
          <p>{{ 'forgot-password.step2.subtitulo' | translate }}</p>
        </div>

        <!-- Formulario -->
        <div class="form-content">
          <div class="code-input-section">
            <div class="code-icon">
              <i class="pi pi-key"></i>
            </div>
            <p-inputOtp
              [(ngModel)]="verificationCode"
              [length]="4"
              separator=" "
              inputId="verificationCode"
              styleClass="custom-otp"
            ></p-inputOtp>
          </div>

          <!-- Timer e Reenvio -->
          <div class="resend-section">
            <div *ngIf="timer > 0" class="timer-display">
              <i class="pi pi-clock"></i>
              <span>{{ 'forgot-password.messages.aguarde' | translate }} <strong>{{ timer }}s</strong></span>
            </div>
            <button
              *ngIf="timer === 0"
              pButton
              type="button"
              [label]="'forgot-password.buttons.reenviar_codigo' | translate"
              icon="pi pi-refresh"
              class="btn-link"
              (click)="reSendCode()"
            ></button>
          </div>

          <!-- Botoes -->
          <div class="buttons-group">
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.voltar' | translate"
              icon="pi pi-arrow-left"
              class="btn-secondary"
              (click)="goBackStep1()"
            ></button>
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.verificar' | translate"
              icon="pi pi-check"
              iconPos="right"
              class="btn-primary"
              [loading]="verificandoCodigo"
              [disabled]="verificandoCodigo"
              (click)="validateCode()"
            ></button>
          </div>
        </div>
      </ng-container>

      <!-- ================================================================== -->
      <!-- STEP 3: Nova Senha -->
      <!-- ================================================================== -->
      <ng-container *ngIf="step === 3">
        <!-- Header do Formulario -->
        <div class="form-header">
          <div class="step-indicator">
            <div class="step completed"><i class="pi pi-check"></i></div>
            <div class="step-line completed"></div>
            <div class="step completed"><i class="pi pi-check"></i></div>
            <div class="step-line completed"></div>
            <div class="step active">3</div>
          </div>
          <h2>{{ 'forgot-password.step3.titulo' | translate }}</h2>
          <p>{{ 'forgot-password.step3.subtitulo' | translate }}</p>
        </div>

        <!-- Formulario -->
        <div class="form-content">
          <!-- Nova Senha -->
          <div class="input-group">
            <label for="newPassword">{{ 'forgot-password.labels.nova_senha' | translate }}</label>
            <div class="input-wrapper password-wrapper">
              <i class="pi pi-lock input-icon"></i>
              <p-password
                [(ngModel)]="newPassword"
                [feedback]="false"
                [toggleMask]="true"
                id="newPassword"
                [placeholder]="'forgot-password.placeholders.digite_a_nova_senha' | translate"
                autocomplete="off"
                styleClass="custom-password"
              ></p-password>
            </div>
          </div>

          <!-- Confirmar Senha -->
          <div class="input-group">
            <label for="confirmPassword">{{ 'forgot-password.labels.confirmar_senha' | translate }}</label>
            <div class="input-wrapper password-wrapper">
              <i class="pi pi-lock input-icon"></i>
              <p-password
                [(ngModel)]="confirmPassword"
                [feedback]="false"
                [toggleMask]="true"
                id="confirmPassword"
                [placeholder]="'forgot-password.placeholders.repita_a_nova_senha' | translate"
                autocomplete="off"
                styleClass="custom-password"
              ></p-password>
            </div>
          </div>

          <!-- Botoes -->
          <div class="buttons-group">
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.cancelar' | translate"
              icon="pi pi-times"
              class="btn-secondary"
              (click)="cancelReset()"
            ></button>
            <button
              pButton
              type="button"
              [label]="'forgot-password.buttons.redefinir_senha' | translate"
              icon="pi pi-check"
              iconPos="right"
              class="btn-primary"
              [loading]="redefinindoSenha"
              [disabled]="redefinindoSenha"
              (click)="updatePassword()"
            ></button>
          </div>
        </div>
      </ng-container>

      <!-- Link Voltar ao Login -->
      <div class="back-to-login">
        <a [routerLink]="['/login']">
          <i class="pi pi-arrow-left"></i>
          {{ 'forgot-password.links.voltar_login' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
